import { useMutation, useQueryClient } from '@tanstack/react-query';

import { useApi } from 'services/api';
import { getConfiguredTimezone } from 'utils/datetime';

const useAcknowledgeByMql = (config) => {
  const queryClient = useQueryClient();
  const api = useApi();
  const timezone = getConfiguredTimezone();

  return useMutation({
    ...config,
    mutationFn: async (mql) => {
      await api.post(
        '/search/bulk/acknowledge',
        {},
        {
          params: {
            query: mql,
            context: [],
            searchType: 'O_NOTIFICATIONS',
            timezone,
          },
        },
      );

      await Promise.all([
        queryClient.resetQueries({
          queryKey: ['notifications'],
        }),
        queryClient.resetQueries({
          queryKey: ['newNotifications'],
        }),
      ]);
    },
  });
};

export default useAcknowledgeByMql;
